<script lang="ts">
  export let color: "light" | "grey" = "grey";
</script>

<div class="container" class:grey-shimmer={color === "light"} />

<style>
  .container {
    display: block;
    position: relative;
    background: var(--rk-neutral-0);
    overflow: hidden;
    height: var(--skeleton-height, 100%);
    width: var(--skeleton-width, 100%);
    border-radius: var(--skeleton-radius, var(--rk-rounding-xxs));
  }

  .grey-shimmer {
    background: #fff;
  }

  .container::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      270deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.14) 10%,
      rgba(255, 255, 255, 0.45) 28.02%,
      rgba(255, 255, 255, 0.65) 43.25%,
      rgba(255, 255, 255, 0.7) 50%,
      rgba(255, 255, 255, 0.65) 56.75%,
      rgba(255, 255, 255, 0.45) 71.98%,
      rgba(255, 255, 255, 0.14) 90%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: skeleton-shimmer 1.2s cubic-bezier(0.42, 0, 0.5, 1) infinite;
    content: "";
  }

  .grey-shimmer::after {
    background-image: linear-gradient(
      270deg,
      rgba(248, 248, 248, 0) 0%,
      rgba(248, 248, 248, 0.14) 10%,
      rgba(248, 248, 248, 0.45) 28.02%,
      rgba(248, 248, 248, 0.65) 43.25%,
      rgba(248, 248, 248, 0.7) 50%,
      rgba(248, 248, 248, 0.65) 56.75%,
      rgba(248, 248, 248, 0.45) 71.98%,
      rgba(248, 248, 248, 0.14) 90%,
      rgba(248, 248, 248, 0) 100%
    );
  }

  @keyframes skeleton-shimmer {
    100% {
      transform: translateX(100%);
    }
  }
</style>
